<template>
  <div v-if="model && model.length">
    <div class="m-b-9">Opening hours:</div>
    <table>
      <tr v-for="(item, index) in getmodel(model)" :key="index">
        <td>{{ insertString("FindStore", getDayString(item.Days)) }}:</td>
        <td class="p-l-12">
          <span>{{ item.OpenHour }}</span>
          <span v-if="item.OpenMinute">.{{ item.OpenMinute }}</span> -
          <span>{{ item.CloseHour }}</span>
          <span v-if="item.CloseMinute">.{{ item.CloseMinute }}</span>
        </td>
      </tr>
    </table>
    <div v-if="exceptions && exceptions.length || exceptions != null" class="m-t-12">
      <table>
        <tr v-for="(item, index) in exceptions" :key="index">
         <td>{{ getDateString(item) }}:</td>
          <td class="p-l-12" v-if="!item.IsClosed">
            <span>{{ item.OpenHour }}</span>
            <span v-if="item.OpenMinute">.{{ item.OpenMinute }}</span>
            <span v-if="!item.IsClosed"> - </span>
            <span>{{ item.CloseHour }}</span>
            <span v-if="item.CloseMinute">.{{ item.CloseMinute }}</span>
          </td>
          <td class="p-l-12" v-else><span>{{ insertString('FindStore', 'Closed') }}</span></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    model: Array
  },
  methods: {
    getmodel (data) {
      const list = data.filter(x => x.Date === null);
      list.sort(function (a, b) {
        if (a.Days < b.Days) return -1;
        if (a.Days > b.Days) return 1;
        return 0;
      });
      return list;
    },
    getDayString (val) {
      return {
        0: 'AllDays',
        1: 'WeekDays',
        2: 'Mon',
        3: 'Tue',
        4: 'Wed',
        5: 'Thu',
        6: 'Fri',
        7: 'Sat',
        8: 'Sun'
      }[val];
    },
    getExceptions (data) {
      const list = data.filter(x => x.Date !== null);
      list.sort(function (a, b) {
        if (a.Days < b.Days) return -1;
        if (a.Days > b.Days) return 1;
        return 0;
      });
      return list;
    },
    getDateString (item) {
      let date;
      if (item.Date.startsWith('/Date(')) {
        const timestamp = parseInt(item.Date.match(/\/Date\((\d+)\)\//)[1], 10);
        date = new Date(timestamp);
      } else {
        date = new Date(item.Date);
      }
      const options = { month: 'long', day: 'numeric' };
      return date.toLocaleDateString(this.lang, options);
    },
    filterExceptions () {
      const data = this.getExceptions(this.model);
      const today = new Date();
      const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const filteredData = data.filter(item => {
        let date;
        if (item.Date.startsWith('/Date(')) {
          const timestamp = parseInt(item.Date.match(/\/Date\((\d+)\)\//)[1], 10);
          date = new Date(timestamp);
        } else {
          date = new Date(item.Date);
        }
        return date >= todayDate;
      });
      return filteredData;
    }
  },
  computed: {
    exceptions () {
      const exceptionDates = this.filterExceptions();
      return exceptionDates.length ? exceptionDates : null;
    },
    lang () {
      return {
        'en-GB': 'en',
        'nb-NO': 'no',
        'sv-SE': 'sv',
        'fr-FR': 'fr',
        'de-DE': 'de'
      }[document.documentElement.lang];
    }
  }
};
</script>
